"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurgeryVitalsRecordingTime_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SurgeryVitalsRecordingTime_Factory = /** @class */ (function () {
    function SurgeryVitalsRecordingTime_Factory() {
    }
    SurgeryVitalsRecordingTime_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ConnectedMonitorId: model.ConnectedMonitorId,
            EndTime: Date_Factory_1.Date_Factory.CreateIncoming(model.EndTime),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            StartTime: Date_Factory_1.Date_Factory.CreateIncoming(model.StartTime),
            SurgeryVitalsId: model.SurgeryVitalsId,
            UserId: model.UserId,
        };
        return result;
    };
    SurgeryVitalsRecordingTime_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ConnectedMonitorId: model.ConnectedMonitorId,
            EndTime: Date_Factory_1.Date_Factory.CreateOutgoing(model.EndTime),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            StartTime: Date_Factory_1.Date_Factory.CreateOutgoing(model.StartTime),
            SurgeryVitalsId: model.SurgeryVitalsId,
            UserId: model.UserId,
        };
        return result;
    };
    return SurgeryVitalsRecordingTime_Factory;
}());
exports.SurgeryVitalsRecordingTime_Factory = SurgeryVitalsRecordingTime_Factory;
